export const promoBannerLandingsPageLinksSelectTranslationKeys = {
  promoLandingLabel: 'promo.landing-label',
}
